module.exports = __webpack_public_path__ + "static/img/14.38e437d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/14.png
// module id = pwXQ
// module chunks = 0